import { User } from '../../Model/dbo/User';
import { useEffect, useState } from "react";
import axios from 'axios';
import Cookies from 'universal-cookie';
import { BaseApi } from './BaseUrl'

export async function LoginStep1(mobile: string): Promise<boolean> {
    try {
        const dt: User = {
            Username: '',
            Password: '',
            PersonelNo: 0,
            Token: '',
            UserId: 0,
            Name: '',
            Unit: '',
            UnitId: 0,
            InsuranceNo: '',
            Job: '',
            IsManager: false,
            Code: 0,
            Mobile: mobile,
            saghfmorakhasi: 0,
            uesedmorakhasi: '',
            remainingmorakhasi: 0,
            hasServey:false
        };
        const requestOptions = {
            method: "POST",
            url: BaseApi + 'Login/Login',
            data: dt,
        };
        const response = await axios(requestOptions);
        const res: boolean = response.data;
        return res;
    }
    catch (error) {
        console.error(error);
        return false;
    }
}

export async function LoginStep2(mobile: string, code: number): Promise<boolean> {
    try {
        const dt: User = {
            Username: '',
            Password: '',
            PersonelNo: 0,
            Token: '',
            UserId: 0,
            Name: '',
            Unit: '',
            UnitId: 0,
            InsuranceNo: '',
            Job: '',
            IsManager: false,
            Code: code,
            Mobile: mobile,
            saghfmorakhasi: 0,
            uesedmorakhasi: '',
            remainingmorakhasi: 0,
            hasServey:false
        };
        const requestOptions = {
            method: "POST",
            url: BaseApi + 'Login/Login',
            data: dt,
        };
        const response = await axios(requestOptions);
        const res: User = response.data;
        if (res) {
            var cook = new Cookies();
            cook.set('user', res);

        }
        return true;
    }
    catch (error) {
        console.error(error);
        return false;
    }
}

export function AddFcm(): boolean {
    try {
        var cook = new Cookies();
        var fcm = cook.get('client');
        var user = cook.get('user');

        var res = true;
        const requestOptions = {
            headers: { 'Authorization': user.Token }
        };
        const response = axios.get(BaseApi + 'Firebase/AddFcmToken?fcm=' + fcm, requestOptions).then(p => {
            if (!p.data) res = false;
        });

        return res;
    }
    catch (error) {

        return false;
    }
}

export function ValidToken(token: string): boolean {
    try {
        const [res, SetRes] = useState<boolean>(false)
        const response = axios.get(BaseApi + 'Login/Checktoken?token=' + token).then(p => {
            SetRes(p.data)
        });

        return res;
    }
    catch (error) {

        return false;
    }
}
